export const handleFormatNumberInputs = function (value: string) {
  let newValue = value.replace(/,/g, "");
  let formattedNumber = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // console.log(formattedNumber);
  return formattedNumber;
};
